// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-1XjWe","checkbox_checked":"checkbox_checked-2_vF7","tooltip_popper":"tooltip_popper-3Xhmk"};